import { useEffect, useRef, useState } from "react";
import Title from "../../components/common/title/Title";
import Button from "../../components/common/button/Button";
import ImagesModal from "../../components/common/modals/imgaes-modal/ImagesModal";
import { getApi, putApi } from "../../services/api/globalApi";
import { PublicFileUrl } from "../../services/config";
import {
  successMessage,
  errorMessage,
} from "../../utils/toastify-message/ToastifyMessage";

const labelClass =
  "block mb-2 text-sm font-medium text-gray-900 dark:text-white";

const SLOTS = [
  { key: "aboutImageUrl", label: "تصویر بخش «درباره ما»" },
  {
    key: "cultureImageUrl",
    label: "تصویر بخش «فرهنگ سازمانی و محیط کاری»",
  },
];

const imageSrc = (name) =>
  name.startsWith("http") ? name : `${PublicFileUrl}public/files/${name}`;

function ImageSlot({ label, value, onPick, onRemove }) {
  return (
    <div>
      <label className={labelClass}>{label}</label>
      <div
        className="relative rounded-xl overflow-hidden border-2 border-dashed border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 cursor-pointer hover:border-green-400 transition-colors"
        style={{ aspectRatio: "5/4" }}
        onClick={onPick}
      >
        {value ? (
          <img
            src={imageSrc(value)}
            alt={label}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center text-gray-400 text-sm gap-2">
            <svg
              className="w-8 h-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span>کلیک کنید برای انتخاب تصویر</span>
          </div>
        )}
      </div>
      {value && (
        <div className="mt-2 flex gap-4">
          <button
            type="button"
            onClick={onPick}
            className="text-xs text-blue-600 hover:text-blue-800 dark:text-blue-400"
          >
            تغییر تصویر
          </button>
          <button
            type="button"
            onClick={onRemove}
            className="text-xs text-red-500 hover:text-red-700"
          >
            حذف تصویر
          </button>
        </div>
      )}
    </div>
  );
}

export default function AboutSettingsForm() {
  const [images, setImages] = useState({
    aboutImageUrl: "",
    cultureImageUrl: "",
  });
  const [fetching, setFetching] = useState(true);
  const [loadFailed, setLoadFailed] = useState(false);
  const [loading, setLoading] = useState(false);
  const imageModal = useRef();
  const activeSlot = useRef(null);

  useEffect(() => {
    getApi({ path: "admin/about-settings" })
      .then((res) => {
        const d = res?.data?.result;
        setImages({
          aboutImageUrl: d?.aboutImageUrl || "",
          cultureImageUrl: d?.cultureImageUrl || "",
        });
      })
      .catch(() => {
        setLoadFailed(true);
        errorMessage("خطا در دریافت تنظیمات؛ صفحه را دوباره بارگذاری کنید");
      })
      .finally(() => setFetching(false));
  }, []);

  const openPicker = (key) => {
    activeSlot.current = key;
    imageModal.current.showModal();
  };

  const handlePicked = (item) => {
    const key = activeSlot.current;
    if (!item || !key) return;
    setImages((prev) => ({ ...prev, [key]: item.name }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await putApi({
        path: "admin/about-settings",
        body: JSON.stringify(images),
      });
      successMessage("تصاویر صفحه درباره ما با موفقیت ذخیره شد");
    } catch (error) {
      console.error(error);
      errorMessage(
        error?.response?.data?.errors?.[0]?.message || "خطایی رخ داد"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="bg-white dark:bg-gray-900 rounded-3xl p-6 relative">
        <Title title="تصاویر صفحه درباره ما" />
        {fetching ? (
          <p className="mt-6 text-gray-500 text-sm">در حال بارگذاری...</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="grid sm:grid-cols-2 gap-6 mt-6 items-start">
              {SLOTS.map((slot) => (
                <ImageSlot
                  key={slot.key}
                  label={slot.label}
                  value={images[slot.key]}
                  onPick={() => openPicker(slot.key)}
                  onRemove={() =>
                    setImages((prev) => ({ ...prev, [slot.key]: "" }))
                  }
                />
              ))}
            </div>
            <div className="mt-6">
              <Button
                text={loading ? "در حال ذخیره..." : "ذخیره تصاویر"}
                type="submit"
                color="success"
                disabled={loading || loadFailed}
              />
            </div>
          </form>
        )}
      </div>
      <ImagesModal selectedImages={handlePicked} ref={imageModal} />
    </>
  );
}
